import { FC } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { ToggleChip } from '@ravago/shared/radiance/components/toggle-chip/components/ToggleChip/ToggleChip';
import { useTranslations } from '@ravago/shared/translations/client';

import { useInvoiceDispatchContext } from '../../context/invoice-context';
import { BillingType } from '../../models/billing-type.model';
import { InvoiceAction } from '../../state/invoice.actions';

type Props = {
   isOpenSelected: boolean;
   hasClosedInvoiceFeatureToggle: boolean;
};

export const InvoiceChipList: FC<Props> = ({ isOpenSelected, hasClosedInvoiceFeatureToggle }) => {
   const translate = useTranslations();
   const dispatch = useInvoiceDispatchContext();

   const handleClick = (selectionType: BillingType) => {
      dispatch({ type: InvoiceAction.SET_BILLING_TYPE, payload: selectionType });
      if (selectionType === BillingType.OPEN) {
         dispatch({ type: InvoiceAction.SET_CLOSED_INVOICES_QUERY_PARAMS, payload: { page: 1, identifier: '' } });
      }
   };

   return (
      <Box>
         <ToggleChip label={translate('invoices.invoice-chip-list.open')} toggled={isOpenSelected} onClick={() => handleClick(BillingType.OPEN)} />
         {hasClosedInvoiceFeatureToggle && (
            <ToggleChip
               label={translate('invoices.invoice-chip-list.closed')}
               toggled={!isOpenSelected}
               onClick={() => handleClick(BillingType.CLOSED)}
            />
         )}
      </Box>
   );
};
